import { Link } from 'react-router-dom';
import Device from './Device';
import Image from './Image';
import { cx } from '../lib/cx';

function Tags({ tags, className }) {
  return (
    <div className={cx('tags', className)}>
      {tags.map((tag) => (
        <span key={tag} className="tag">{tag}</span>
      ))}
    </div>
  );
}

function ProjectCover({ project }) {
  const cover = project.cover;
  if (cover.tile === 'hero') {
    return (
      <div className="hero-cover-wrapper">
        <Image src={cover.fg} className="fg" alt="" />
        <Image src={cover.bg} className="bg" alt="" />
        <div className="fade" />
      </div>
    );
  }
  return (
    <div className="img-wrapper">
      <Image src={cover.bg} alt={cover.alt || project.title} />
      {cover.device ? (
        <div className="device-container">
          <Device {...cover.device} />
        </div>
      ) : null}
    </div>
  );
}

function ProjectTile({ project }) {
  const inner = (
    <>
      <ProjectCover project={project} />
      <div className="content-wrapper">
        <div className="content">
          <h2 className="mb-3">{project.shortTitle || project.title}</h2>
          <Tags tags={project.homeTags || project.tags} />
        </div>
        <div className="fade show" />
      </div>
    </>
  );

  return (
    <div className="item">
      {project.published ? (
        <Link to={project.path}>{inner}</Link>
      ) : (
        <div className="no-link">{inner}</div>
      )}
    </div>
  );
}

export default function ProjectSection({ featured, projects }) {
  return (
    <div id="work">
      <div className="projects-pin-placeholder" aria-hidden="true" />
      <section
        id="projects"
        className="region section-screen-h theme"
        data-bg="var(--color-tertiary-a)"
        data-color="var(--color-secondary)"
        data-highlight="var(--color-primary)"
        data-highlight-color="var(--color-secondary)"
        data-start="complete"
      >
        <article>
          <div className="contain container-fluid container-limit px-0">
            <div className="projects-intro-proxy-host" />
            <div className="content-scroll">
              <div className="contain container">
                <h1 className="display">{featured.title}</h1>
              </div>
            </div>
            <div className="content-fixed">
              <div className="container">
                <div className="flex flex-wrap">
                  <div className="w-full md:w-1/2">
                    <p className="intro">{featured.intro}</p>
                    <Tags tags={featured.tags} className="mb-4" />
                    <Link to={`/projects/${featured.slug}`} className="btn btn-primary">View Project</Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="content-grid">
              <div className="grid">
                {projects.map((project) => (
                  <ProjectTile key={project.slug} project={project} />
                ))}
              </div>
            </div>
          </div>
        </article>
      </section>
      <div className="projects-pin-end" aria-hidden="true" />
    </div>
  );
}
